import { getPostHog, onPostHogReady } from '../../../instrumentation-client'

// biome-ignore lint/suspicious/noExplicitAny: PostHog accepts any properties object
export function captureEvent(eventName: string, properties?: Record<string, any>): void {
  const posthog = getPostHog()
  if (posthog) {
    posthog.capture(eventName, properties)
    return
  }
  // PostHog is still loading — queue the event for when it's ready
  onPostHogReady((ph) => {
    ph.capture(eventName, properties)
  })
}
